import angular from 'angular';

import errorCodes from './config/errorcodes.conf';

import messageRouting from './message-routing-module';
import messagesList from './components/messages-list/messages-list-module';
import sentMessagesList from './components/sent-messages-list/sent-messages-list-module';
import sentMessageDetails from './components/sent-message-details/sent-message-details-module';
import messageDetails from './components/message-details/message-details-module';
import createMessage from './components/create-message/create-message-module';
import messagesTab from './components/messages-tab/messages-tab-module';
import recipientsList from './components/recipients-list/recipients-list-module';
import replyMessageDialogModule from './components/reply-message-dialog/reply-message-dialog-module';

import messageDefinitionService from './message-definition-service';

export default angular
  .module('message', [
    errorCodes.name,
    replyMessageDialogModule.name,
    messageRouting.name,
    messagesList.name,
    sentMessagesList.name,
    sentMessageDetails.name,
    messageDetails.name,
    createMessage.name,
    messagesTab.name,
    recipientsList.name,
  ])
  .service('messageDefinitionService', messageDefinitionService);



// WEBPACK FOOTER //
// ./src/modules/message/message-component.js